import React from "react";

interface Props {
  fallback: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The badge page mounts straight at the React root with Sentry deliberately off,
 * so an uncaught render throw leaves an anonymous scanner on a blank page with
 * nothing to report. The fallback is passed in to keep this file free of the
 * page's imports — the page owns the card, this owns only the catch.
 */
export class BadgeErrorBoundary extends React.Component<
  Props,
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render(): React.ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
